var map = {
	"./SkillsImages/Bootstrap.png": 60,
	"./SkillsImages/CSS.png": 61,
	"./SkillsImages/Git.png": 62,
	"./SkillsImages/HTML.png": 63,
	"./SkillsImages/IntelliJ.png": 64,
	"./SkillsImages/Java.png": 65,
	"./SkillsImages/Node.png": 66,
	"./SkillsImages/Postman.png": 67,
	"./SkillsImages/Python.png": 68,
	"./SkillsImages/Redux.png": 69,
	"./SkillsImages/Sass.png": 70,
	"./SkillsImages/Slack.png": 71,
	"./SkillsImages/Spring.png": 72,
	"./SkillsImages/VSCode.png": 73,
	"./SkillsImages/firebase.png": 74,
	"./SkillsImages/jquery.png": 75,
	"./SkillsImages/mongo.png": 76,
	"./SkillsImages/typescript.png": 77,
	"./SkillsImages/vue.png": 78,
	"./SpotifySuggester2-min.png": 130,
	"./citrics-min.png": 131,
	"./cocktails-screenshot-min.png": 132,
	"./reducer-todo-min.png": 133,
	"./secret-recipe-min.png": 134,
	"./shoppies-min.png": 135,
	"./spotify-suggester-min.png": 136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;